/*
 * @Description:
 * @Autor: Dai YueLin
 * @Date: 2021-07-06 15:21:50
 * @LastEditors: Dai YueLin
 * @LastEditTime: 2022-09-22 14:10:35
 */
import NProgress from 'nprogress'; // progress bar

import { getUrlKey } from '@/utils/storage';
import { getToken, getUserInfo } from '@/api/login';
import { setSession } from '@/utils/storage';

import { getQueryString } from './utils/baseTool';
import router from './router';
import 'nprogress/nprogress.css'; // progress bar style
import store from './store';
import { setToken, jumpBackByLogin, jumpLogin } from './utils/system';
import { replaceToken } from './api/login';

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const didloginUrl = import.meta.env.VITE_GLOB_DID_URL;
router.beforeEach(async (to, from, next) => {
  to.meta.from = from;
  NProgress.start();
  const urlCode: any = getQueryString('code');
  if (window?.location.origin.includes('edm-dev') && urlCode) {
    setSession('code', urlCode);
  }
  if (urlCode) {
    next(false);
    getToken({ code: urlCode })
      .then((data: any) => {
        if (data.token) {
          setToken(data.token);
          store.dispatch('user/loginByToken', data.token).then(() => {
            getUserInfo().then((res: any) => {
              window.localStorage.setItem('userInfo', JSON.stringify(res || {}));
              window.localStorage.setItem('rbacPriList', JSON.stringify(res.rbacPriList));
              store.commit('user/SET_PRILIST', res.rbacPriList);

              jumpBackByLogin();
            });
          });
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  } else {
    let urlToken: any = getUrlKey('token');
    if (urlToken !== '' && urlToken !== null) {
      const data = await replaceToken({ token: urlToken });
      setToken(data.token);
      store.dispatch('user/loginByToken', data.token);

      jumpBackByLogin();
    } else {
      urlToken = false;
    }
    if (store.getters.token) {
      next();
    } else {
      jumpLogin(didloginUrl);
      NProgress.done();
    }
  }
});

router.afterEach((to) => {
  // 批量埋点
  if (to.meta.mid) {
    window.$track.pv(to.meta.mid);
  }
  NProgress.done();
});
